import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromClient from '@core/state/client/client.reducers';

export const selectClientState = createFeatureSelector<fromClient.State>(fromClient.featureName);
export const selectContacts = createSelector(selectClientState, state => state.contacts);
export const selectAvalaraClient = createSelector(selectClientState, state => state.avalaraClientId);
